import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import centerSvg from '@/images/toolbar/align/Center.svg';
import leftSvg from '@/images/toolbar/align/Left.svg';
import rightSvg from '@/images/toolbar/align/Right.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { ElementType } from 'polotno/model/group-model';
import { ControlButton } from '../../common/ControlButton';

const Container = styled.div`
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
`;

export const AlignTextControl = observer(() => {
    const { store } = useAdvancedEditorContext();
    const elements = store.selectedElements;
    const element = elements[0] as ElementType & { align: string };

    function handleClick(align: 'left' | 'center' | 'right') {
        store.selectedElements.forEach(element => element.set({ align }));
    }

    return (
        <Container>
            <ControlButton onClick={() => handleClick('left')} selected={element.align === 'left'}>
                <MaskedIcon src={leftSvg} size="20px" />
            </ControlButton>
            <ControlButton onClick={() => handleClick('center')} selected={element.align === 'center'}>
                <MaskedIcon src={centerSvg} size="20px" />
            </ControlButton>
            <ControlButton onClick={() => handleClick('right')} selected={element.align === 'right'}>
                <MaskedIcon src={rightSvg} size="20px" />
            </ControlButton>
        </Container>
    );
});
